"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_CREATE_SESSION_SOURCE = exports.CONVERSION_HYPOTHESIS_EVIDENCE_SOURCE = exports.CONVERSION_HYPOTHESIS_CONFIDENCE = exports.DEEP_LINK_PAGE_STRUCTURES = exports.AI_CREATE_SESSION_SSE_EVENT = exports.AI_CREATE_SESSION_STATUS = exports.AI_CREATE_VARIANT_STATUS = exports.DEEP_LINK_ANALYSIS_STATUS = exports.VARIANT_COUNT_OPTIONS = exports.MAX_VARIANT_COUNT = exports.AD_PLATFORM = void 0;
exports.variantProgressKey = variantProgressKey;
exports.AD_PLATFORM = {
    UNSPECIFIED: 'UNSPECIFIED',
    META: 'META',
    GOOGLE: 'GOOGLE',
    TIKTOK: 'TIKTOK',
    AXON: 'AXON',
    PINTEREST: 'PINTEREST',
    SNAPCHAT: 'SNAPCHAT',
    ROKT: 'ROKT',
};
// Variant count bounds for AI Create storefront generation. Lives here so the
// frontend selector, the backend clamp in `normalizeVariantCount`, and any
// future caller share one source of truth — changing the max ripples
// automatically.
exports.MAX_VARIANT_COUNT = 5;
exports.VARIANT_COUNT_OPTIONS = Array.from({ length: exports.MAX_VARIANT_COUNT }, (_, i) => i + 1);
// Deep-link analysis runs on a parallel track from session.status; this signal
// lets the FE gate work on it without guessing from `status`.
exports.DEEP_LINK_ANALYSIS_STATUS = {
    PENDING: 'pending',
    READY: 'ready',
    UNAVAILABLE: 'unavailable',
};
exports.AI_CREATE_VARIANT_STATUS = {
    PENDING: 'pending',
    GENERATING: 'generating',
    GENERATED: 'generated',
    REVIEWING: 'reviewing',
    REVISING: 'revising',
    DONE: 'done',
    FAILED: 'failed',
};
exports.AI_CREATE_SESSION_STATUS = {
    PENDING: 'PENDING',
    VIDEO_PROCESSING_UPLOADING: 'VIDEO_PROCESSING_UPLOADING',
    VIDEO_PROCESSING_TRANSCRIBING: 'VIDEO_PROCESSING_TRANSCRIBING',
    VIDEO_PROCESSING_COMPLETE: 'VIDEO_PROCESSING_COMPLETE',
    VIDEO_PROCESSING_FAILED: 'VIDEO_PROCESSING_FAILED',
    CREATIVE_ANALYZING: 'CREATIVE_ANALYZING',
    CREATIVE_ANALYSIS_COMPLETE: 'CREATIVE_ANALYSIS_COMPLETE',
    CREATIVE_ANALYSIS_FAILED: 'CREATIVE_ANALYSIS_FAILED',
    DEEP_LINK_ANALYZING: 'DEEP_LINK_ANALYZING',
    DEEP_LINK_ANALYSIS_COMPLETE: 'DEEP_LINK_ANALYSIS_COMPLETE',
    PERSONAS_RANKING: 'PERSONAS_RANKING',
    PERSONAS_RANKED: 'PERSONAS_RANKED',
    TEMPLATES_RANKING: 'TEMPLATES_RANKING',
    TEMPLATES_RANKED: 'TEMPLATES_RANKED',
    CONTENT_GENERATING: 'CONTENT_GENERATING',
    TEMPLATE_DUPLICATED: 'TEMPLATE_DUPLICATED',
    LLM_GENERATION_COMPLETE: 'LLM_GENERATION_COMPLETE',
    IMAGE_CURATION_COMPLETE: 'IMAGE_CURATION_COMPLETE',
    CONTENT_GENERATED: 'CONTENT_GENERATED',
    FAILED: 'FAILED',
    HYPOTHESIS_GENERATING: 'HYPOTHESIS_GENERATING',
    HYPOTHESIS_GENERATED: 'HYPOTHESIS_GENERATED',
};
/** Stable identity of a variant entry: its position in the run. */
function variantProgressKey(variant) {
    return `page-${variant.variantIndex}`;
}
/** SSE event names for `GET …/ai-create-session/:sessionId/events`. */
exports.AI_CREATE_SESSION_SSE_EVENT = {
    SNAPSHOT: 'snapshot',
    UPDATE: 'update',
    DONE: 'done',
    PING: 'ping',
};
exports.DEEP_LINK_PAGE_STRUCTURES = [
    'PDP',
    'COLLECTION',
    'HOMEPAGE',
    'CUSTOM_LANDING',
    'ARTICLE',
    'OTHER',
];
exports.CONVERSION_HYPOTHESIS_CONFIDENCE = [
    'clean',
    'stretch',
    'open_question',
];
exports.CONVERSION_HYPOTHESIS_EVIDENCE_SOURCE = [
    'ad',
    'destination',
    'product',
    'operator',
];
exports.AI_CREATE_SESSION_SOURCE = {
    META_AD: 'meta_ad',
    MANUAL: 'manual',
    SEARCH_QUERY: 'search_query',
};
